export default __webpack_public_path__ + "static/media/investaX.6008dbce.jpg";